
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BtnRadio from "@common/src/components/scope/btn-radio/index.vue";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import echarts from "echarts";
import { addCurrencyUnit, formDownload } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import t from "@common/src/i18n/t";
import ChartDate from "@common/src/components/scope/chart-date/index.vue";
const finance = namespace("finance");

@Component({
  components: { BtnRadio, TextTips, ChartDate }
})
@Table("loadListData")
export default class ReportOutputValue extends Vue {
  @finance.Action getGrossProfitListV2;
  @finance.Action getGrossProfitReportV2;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  chartFormData: any = {
    statisticMethod: 1,
    beginTime: "",
    endTime: ""
  };
  listFormData: any = {
    statisticMethod: 1,
    beginTime: "",
    endTime: ""
  };
  nowDate: any = dayjs();
  tableData: any = [];
  grossProfitListData: any = [];
  created() {
    this.init();
  }
  myChart: any = {};
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(this.$refs.outputPie);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }
  init() {
    //
  }
  draw(serverData?) {
    let listData =
      this.chartFormData.statisticMethod === "1" ? serverData.data?.monthTrend || [] : serverData.data?.yearTrend || [];
    let xData = [];
    let data = [];
    listData.forEach(item => {
      if (this.chartFormData.statisticMethod === "1") {
        xData.push(dayjs(item.title).format("MM-DD"));
      } else {
        xData.push(dayjs(item.title).format("YYYY-MM"));
      }
      data.push(item.grossProfitAmount);
    });
    let options = {
      xAxis: {
        type: "category",
        data: xData,
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          },
          rotate: this.chartFormData.statisticMethod === "1" ? 40 : 0 //倾斜度可以根据需求设置
        },
        axisLine: {
          lineStyle: {
            color: "#8C8C8C"
          }
        }
      },
      tooltip: {
        trigger: "axis",
        formatter: params => {
          return `${params[0].name}<br/>${t("finance.gross-margin")}: ${
            this.$localMark.currencySymbol + splitThousands(params[0].value)
          }`;
        }
      },
      legend: {
        data: [t("finance.gross-margin")],
        right: 10
      },
      grid: {
        x: 100,
        y: 45,
        x2: 100,
        y2: 40,
        borderWidth: 1
      },
      yAxis: {
        name: t("base.unit") + "：" + this.$localMark.currency,
        type: "value",
        axisLabel: {
          textStyle: {
            //文字样式
            color: "#8C8C8C",
            fontSize: "12"
          }
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      color: ["#FF9900"],
      series: [
        {
          name: t("finance.gross-margin"),
          data: data,
          type: "line"
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
  }
  grossProfitData: any = {};
  @Table.LoadDataMethod()
  loadListData() {
    let params = Object.assign({}, this.listFormData, {
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    });
    return this.getGrossProfitListV2(params).then(data => {
      this.grossProfitData = data.data;
      this.grossProfitListData = data.data.list.map(item => {
        return item;
      });
      return data;
    });
  }
  loadChartData() {
    this.getGrossProfitReportV2(this.chartFormData).then(data => {
      this.draw(data);
    });
  }
  handleLinkView(row) {
    let { href } = this.$router.resolve({
      path: `/finance/collection-order-view/${row.receiptNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkOrderView(orderId) {
    const { href } = this.$router.resolve(`/service/view/${orderId}`);
    window.open(href);
  }
  handleLinkOutWarehouseView(outId) {
    const { href } = this.$router.resolve(`/inventory/out-warehouse-view/${outId}`);
    window.open(href);
  }
  trendDateChange(data) {
    this.chartFormData.statisticMethod = data.type;
    this.chartFormData.beginTime = data.value[0];
    this.chartFormData.endTime = data.value[1];
    this.loadChartData();
  }
  tableDateChange(data) {
    this.listFormData.statisticMethod = data.type;
    this.listFormData.beginTime = data.value[0];
    this.listFormData.endTime = data.value[1];
    this.loadListData();
  }
  handleExportData() {
    formDownload(`${window.API_URL}/report/v2/exportGrossProfit`, this.listFormData);
  }
}
